module.exports = __webpack_public_path__ + "static/media/il.c0a0925b.svg";